<template>
  <div class="sd-card overflow-hidden">
    <div class="overflow-x-auto">
      <table class="sd-table sd-table--compact w-full text-sm">
        <thead>
          <tr>
            <th class="text-left">{{ $t("securone.ack.recipient") }}</th>
            <th class="text-left">{{ $t("securone.ack.unit") }}</th>
            <th class="text-left">{{ $t("securone.ack.state") }}</th>
            <th class="text-right">{{ $t("securone.ack.time") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="a in appRows" :key="a._id" class="border-b border-secondary-100 last:border-0">
            <td class="px-4 py-2">
              <div class="flex items-center gap-3">
                <SoAvatar :name="a.name" size="sm" />
                <span class="text-gray-800">{{ a.name }}<span v-if="a.isMe" class="text-gray-400"> ({{ $t("securone.common.you") }})</span></span>
              </div>
            </td>
            <td class="px-4 py-2 text-gray-500">{{ (a.unitNames || []).join(", ") || "—" }}</td>
            <td class="px-4 py-2"><SoChip>{{ stateLabel(a) }}</SoChip></td>
            <td class="px-4 py-2 text-right text-gray-500 font-mono">{{ stateTime(a) }}</td>
          </tr>
          <tr v-if="appRows.length === 0">
            <td colspan="4" class="px-4 py-6 text-center text-gray-400">{{ $t("securone.ack.no_recipients") }}</td>
          </tr>
          <tr v-if="moreAlerted > 0" class="border-t border-secondary-100">
            <td colspan="4" class="px-4 py-2 text-gray-500 text-xs">{{ $t("securone.ack.more_alerted", { n: moreAlerted }) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="smsRows.length" class="bg-gray-50 border-t border-secondary-200 px-4 py-1 text-xxs uppercase tracking-wider text-gray-500 font-bold">{{ $t("securone.ack.sms_contacts") }}</div>
    <div v-for="s in smsRows" :key="s._id" class="flex items-center gap-3 px-4 py-2 border-t border-secondary-100 text-sm">
      <SoAvatar :name="s.name" size="sm" muted />
      <span class="text-gray-800">{{ s.name }}</span>
      <span class="ml-auto text-xs text-gray-500">{{ $t("securone.ack.sent_as_sms") }}</span>
    </div>
  </div>
</template>

<script>
import SoAvatar from "./SoAvatar.vue";
import SoChip from "./SoChip.vue";
import { clock } from "../securone.helpers";

// Names and a count. Neutral chips: Acknowledged / Seen / Alerted. Never
// "responding", "on the way" or an aggregate "handled".
export default {
  name: "AckList",
  components: { SoAvatar, SoChip },
  props: {
    acknowledgements: { type: Array, default: () => [] },
    recipientCount: { type: Number, default: 0 },
  },
  computed: {
    appRows() {
      return this.acknowledgements.filter((a) => a.channel !== "sms");
    },
    smsRows() {
      return this.acknowledgements.filter((a) => a.channel === "sms");
    },
    moreAlerted() {
      return Math.max(0, this.recipientCount - this.appRows.length);
    },
  },
  methods: {
    stateLabel(a) {
      if (a.state === "acknowledged") return this.$t("securone.ack.acknowledged");
      if (a.seenAt || a.state === "seen") return this.$t("securone.ack.seen");
      return this.$t("securone.ack.alerted");
    },
    stateTime(a) {
      if (a.state === "acknowledged") return clock(a.acknowledgedAt);
      if (a.seenAt) return clock(a.seenAt);
      return "—";
    },
  },
};
</script>
